export default __webpack_public_path__ + "static/media/down-arrow.86055a84.svg";